export default __webpack_public_path__ + "static/media/DEX_KNOWS.006f22e5.png";